export enum VideoPlayers {
  JWPLAYER = 'jwPlayer',
  VIMEO = 'vimeo',
}

export enum Players {
  MAIN = 'player-tm1',
  PIP = 'player-pip',
}
